module.exports = __webpack_public_path__ + "static/media/Puppy-and-Kitten.f8b24801.png";